import { Modal, ROLE } from 'baseui/modal';
import Image from 'next/image';
import * as React from 'react';

interface Props {
  onClose: () => void;
  url: string;
}

export default function PreviewImageDialog(props: Props) {
  return (
    <Modal
      closeable
      isOpen
      animate
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      onClose={props.onClose}
      // size={SIZE.auto}
      role={ROLE.dialog}
      overrides={{
        Root: {
          style: {
            zIndex: 300,
          },
        },
        Dialog: {
          style: {
            display: 'flex',
            flexDirection: 'column',
            width: '80vw',
            height: '90vh',
          },
        },
      }}
    >
      <Image
        src={props.url}
        alt={props.url}
        objectFit="contain"
        layout="fill"
        style={{ paddingLeft: 8, paddingRight: 8 }}
      />
    </Modal>
  );
}
